import { Navigation, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import EFPicture from 'elem/compCommon/EFPicture';
import { useMemo } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function N() {
    const { useLang, useRouter, Link, useState, useEffect } = useGlobal();
    const { t } = useLang('RV');
    const { locale } = useRouter();
    const [active, setActive] = useState(0);
    const tabs: any = [t('K_tab1'), t('K_tab2'), t('K_tab3')];

    const [gap, setGap] = useState(24);
    // 本地化博客blog
    const LOCAL_SITES: string[] = ['es', 'it', 'uk', 'eu', 'fr'];
    const EU_SITES: string[] = ['de', 'fr', 'eu', 'cis'];
    const lists: any = {
        de: [
            {
                img: '/responsive/picture/outdoor-recreation/13_1',
                desc: t('K_card1_text'),
                link: t('K_card1_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_2',
                desc: t('K_card2_text'),
                link: t('K_card2_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_3',
                desc: t('K_card3_text'),
                link: t('K_card3_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_4',
                desc: t('K_card4_text'),
                link: t('K_card4_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_5',
                desc: t('K_card5_text'),
                link: t('K_card5_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_6',
                desc: t('K_card6_text'),
                link: t('K_card6_link'),
            },
        ],
        fr: [
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717081394200/11_1_fr.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717081430101/11_1_375_fr.jpg',
                },
                desc: t('K_card1_text'),
                link: t('K_card1_link'),
            },
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717081459837/11_2_fr.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717081473790/11_2_375_fr.jpg',
                },
                desc: t('K_card2_text'),
                link: t('K_card2_link'),
            },
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717081486678/11_3_fr.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717081500502/11_3_375_fr.jpg',
                },
                desc: t('K_card3_text'),
                link: t('K_card3_link'),
            },
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717081516564/11_4_fr.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717081527793/11_4_375_fr.jpg',
                },
                desc: t('K_card4_text'),
                link: t('K_card4_link'),
            },
            {
                img: {
                    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717081542869/11_5_fr.jpg',
                    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717081553793/11_5_375_fr.jpg',
                },
                desc: t('K_card5_text'),
                link: t('K_card5_link'),
            },
        ],
        uk: {
            0: [
                {
                    img: '/responsive/picture/outdoor-recreation/13_1',
                    desc: t('K_tab1_card1_text'),
                    link: t('K_tab1_card1_link'),
                },
                {
                    img: '/responsive/picture/outdoor-recreation/13_2',
                    desc: t('K_tab1_card2_text'),
                    link: t('K_tab1_card2_link'),
                },
                {
                    img: '/responsive/picture/outdoor-recreation/13_3',
                    desc: t('K_tab1_card3_text'),
                    link: t('K_tab1_card3_link'),
                },
                {
                    img: '/responsive/picture/outdoor-recreation/13_4',
                    desc: t('K_tab1_card4_text'),
                    link: t('K_tab1_card4_link'),
                },
                {
                    img: '/responsive/picture/outdoor-recreation/13_5',
                    desc: t('K_tab1_card5_text'),
                    link: t('K_tab1_card5_link'),
                },
            ],
            1: [
                {
                    img: '/responsive/picture/outdoor-recreation/13_6',
                    desc: t('K_tab2_card1_text'),
                    link: t('K_tab2_card1_link'),
                },
                {
                    img: '/responsive/picture/outdoor-recreation/13_7',
                    desc: t('K_tab2_card2_text'),
                    link: t('K_tab2_card2_link'),
                },
                {
                    img: '/responsive/picture/outdoor-recreation/13_8',
                    desc: t('K_tab2_card3_text'),
                    link: t('K_tab2_card3_link'),
                },
            ],
            2: [
                {
                    img: '/responsive/picture/outdoor-recreation/13_9',
                    desc: t('K_tab3_card1_text'),
                    link: t('K_tab3_card1_link'),
                },
                {
                    img: '/responsive/picture/outdoor-recreation/13_10',
                    desc: t('K_tab3_card2_text'),
                    link: t('K_tab3_card2_link'),
                },
            ],
        },
        it: [
            {
                img: '/responsive/picture/outdoor-recreation/13_1',
                desc: t('K_card1_text'),
                link: t('K_card1_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_2',
                desc: t('K_card2_text'),
                link: t('K_card2_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_3',
                desc: t('K_card3_text'),
                link: t('K_card3_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_4',
                desc: t('K_card4_text'),
                link: t('K_card4_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_5',
                desc: t('K_card5_text'),
                link: t('K_card5_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_6',
                desc: t('K_card6_text'),
                link: t('K_card6_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_7',
                desc: t('K_card7_text'),
                link: t('K_card7_link'),
            },
        ],
        es: [
            {
                img: '/responsive/picture/outdoor-recreation/13_1',
                desc: t('K_card1_text'),
                link: t('K_card1_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_2',
                desc: t('K_card2_text'),
                link: t('K_card2_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_3',
                desc: t('K_card3_text'),
                link: t('K_card3_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_4',
                desc: t('K_card4_text'),
                link: t('K_card4_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_5',
                desc: t('K_card5_text'),
                link: t('K_card5_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_6',
                desc: t('K_card6_text'),
                link: t('K_card6_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_7',
                desc: t('K_card7_text'),
                link: t('K_card7_link'),
            },
        ],
    };
    const [items, setItems] = useState(
        Array.isArray(lists[locale] || lists.uk) ? lists[locale] || lists.uk : lists[locale] ? lists[locale][active] : lists.uk[active],
    );

    useEffect(() => {
        setItems(Array.isArray(lists[locale] || lists.uk) ? lists[locale] || lists.uk : lists[locale] ? lists[locale][active] : lists.uk[active]);
    }, [active, locale]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resetGap = () => {
                const winW = window.innerWidth;
                if (winW >= 1440) {
                    return setGap(24);
                } else if (winW > 1024) {
                    return setGap(20);
                } else {
                    return setGap(16);
                }
            };
            resetGap();
        }
    }, []);

    const renderSwiper = useMemo(() => {
        return (
            <Swiper
                className={`swiper-box swiper-box-${active}`}
                effect="fade"
                modules={[Scrollbar, Navigation]}
                navigation={true}
                spaceBetween={gap}
                slidesPerView={'auto'}
                initialSlide={0}
                scrollbar={{
                    hide: false,
                    draggable: true,
                    dragSize: 32,
                    snapOnRelease: true,
                }}
            >
                {items?.map((card: any, k: number) => (
                    <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                        <EFPicture
                            className="card-img"
                            src={
                                locale === 'fr'
                                    ? card.img.pc
                                    : `${card?.img}${
                                          LOCAL_SITES.includes(locale) ? `_${locale === 'eu' ? 'uk' : locale}` : EU_SITES.includes(locale) ? `_de` : ''
                                      }.jpg`
                            }
                            srcPad={
                                locale === 'fr'
                                    ? card.img.h5
                                    : `${card?.img}_375${
                                          LOCAL_SITES.includes(locale) ? `_${locale === 'eu' ? 'uk' : locale}` : EU_SITES.includes(locale) ? `_de` : ''
                                      }.jpg`
                            }
                            srcMobile={
                                locale === 'fr'
                                    ? card.img.h5
                                    : `${card?.img}_375${
                                          LOCAL_SITES.includes(locale) ? `_${locale === 'eu' ? 'uk' : locale}` : EU_SITES.includes(locale) ? `_de` : ''
                                      }.jpg`
                            }
                            alt={card.desc}
                        />
                        <p className="card-desc">{card?.desc}</p>
                        <Link className="card-link" href={card?.link}>
                            <span className="link-text">{t('F_more')}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                <path
                                    d="M6.50006 12.3291L10.5001 8.3291L6.50006 4.3291"
                                    stroke="#2673FF"
                                    strokeWidth="1.33333"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </Link>
                    </SwiperSlide>
                ))}
            </Swiper>
        );
    }, [active, items, gap, locale]);

    return (
        <div id="RV-K" className={`RV-K RV-box ${css['RV-K']}`}>
            <div className="info-box">
                <p className="title">{t('K_title')}</p>
                <ul className="tabs">
                    {tabs?.map((tab: string, k: number) => (
                        <li className={`tab ${active === k ? 'active' : ''}`} key={k} onClick={() => setActive(k)}>
                            {tab}
                        </li>
                    ))}
                </ul>
            </div>
            <div className="inner">{renderSwiper}</div>
        </div>
    );
}
